var map = {
	"./Foto 1.jpg": 4345,
	"./Foto 10.jpg": 965,
	"./Foto 11.jpg": 7000,
	"./Foto 12.jpg": 5671,
	"./Foto 13.jpg": 7386,
	"./Foto 14.jpg": 3225,
	"./Foto 15.jpg": 5436,
	"./Foto 16.jpg": 1883,
	"./Foto 17.jpg": 1726,
	"./Foto 2.jpg": 7230,
	"./Foto 20.jpg": 2420,
	"./Foto 3.jpg": 5275,
	"./Foto 4.jpg": 1832,
	"./Foto 5.jpg": 9701,
	"./Foto 6.jpg": 3450,
	"./Foto 7.jpg": 9287,
	"./Foto 8.jpg": 228,
	"./Foto 9.jpg": 4561
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4283;